import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { sites } from "@/mocks/sites";

const popularSites = [...sites].sort((a, b) => b.visits - a.visits).slice(0, 8);

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-compass-3-line text-lg"></i>
              </span>
              <span className="text-lg font-extrabold text-background-50">网址导航</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              网址导航是实用型网址导航平台，通过分类与精选方式提供丰富、最新的热门网站入口，帮助你节省搜索时间、提升上网效率。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">热门分类</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="text-primary-200 transition-colors hover:text-background-50">
                    {c.name}导航
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">热门网站</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {popularSites.map((s) => (
                <li key={s.id}>
                  <Link to={`/detail/${s.id}`} className="text-primary-200 transition-colors hover:text-background-50">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">关于本站</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-primary-200 transition-colors hover:text-background-50">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 transition-colors hover:text-background-50">
                  使用说明
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 transition-colors hover:text-background-50">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/search?q=工具" className="text-primary-200 transition-colors hover:text-background-50">
                  搜索热门工具
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 网址导航 · 快速访问热门网站的入口</p>
          <p className="text-primary-300">
            本站为网址导航演示站点，所有链接均直接跳转至第三方网站，相关内容版权归原网站所有。
          </p>
        </div>
      </div>
    </footer>
  );
}